import React, { Component } from "react";
import InactivityTimer from "./inactivityTimer";
import { storage, scopedTokenKey } from "../scopedStorage";

// `loginPath` is where a session-ending logout should land the user — each
// stakeholder has its own login route (e.g. "/aggregation", "/factoryLogin"),
// so every call site below must pass its own.
const WithInactivityTimer = (WrappedComponent, loginPath) => {
  return class extends Component {
    handleLogout = () => {
      storage.clearScoped();
      // A hard navigation, not history.push: a forced logout should also
      // tear down any open Pusher/PubNub sockets and running intervals that
      // a soft route change would leave dangling.
      window.location.href = loginPath || "/";
    };

    // A logout (or a fresh login) in one tab removes/overwrites this app's
    // own scoped token key in localStorage (e.g. "aggregation_token"). That
    // fires a native `storage` event in every OTHER tab on the same origin —
    // without listening for it, those tabs keep rendering as authenticated
    // until their next API call 401s. Only react to the key actually being
    // removed (logout of THIS app, here or in a sibling tab); a new value
    // being written (a login) is not this tab's business to act on, and a
    // different app's scoped key changing is not this app's session at all.
    handleStorageChange = (event) => {
      if (event.key === scopedTokenKey() && !event.newValue) {
        this.handleLogout();
      }
    };

    componentDidMount() {
      window.addEventListener("storage", this.handleStorageChange);
    }

    componentWillUnmount() {
      window.removeEventListener("storage", this.handleStorageChange);
    }

    render() {
      return (
        <div>
          <InactivityTimer onIdle={this.handleLogout} />
          <WrappedComponent {...this.props} />
        </div>
      );
    }
  };
};

export default WithInactivityTimer;
